import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IApiResponse, IOrder } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getOrdersUUID = createUUID();

export const useOrders = () => {
  const stateManager = useComponentState();

  const [orders, setOrders] = useState<IOrder[]>([]);

  const getOrders = async (
    params?: IApiRequest<IOrder>
  ): Promise<IApiResponse<IOrder[]>> => {
    stateManager.abort(getOrdersUUID);
    return stateManager.run(async () => {
      const response = await taskService.order.getAll(params);

      if (response.status === HTTP_STATUSES.OK) {
        setOrders(response.data);
      }

      return response;
    }, getOrdersUUID);
  };

  return {
    orders,
    isLoading: stateManager.isBusy(),
    setOrders,
    getOrders,
  };
};
